/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateProtocolDeployment200ResponseData } from './UpdateProtocolDeployment200ResponseData';
import {
    UpdateProtocolDeployment200ResponseDataFromJSON,
    UpdateProtocolDeployment200ResponseDataFromJSONTyped,
    UpdateProtocolDeployment200ResponseDataToJSON,
    UpdateProtocolDeployment200ResponseDataToJSONTyped,
} from './UpdateProtocolDeployment200ResponseData';

/**
 * 
 * @export
 * @interface UpdateProtocolDeployment200Response
 */
export interface UpdateProtocolDeployment200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProtocolDeployment200Response
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateProtocolDeployment200Response
     */
    message?: string;
    /**
     * 
     * @type {UpdateProtocolDeployment200ResponseData}
     * @memberof UpdateProtocolDeployment200Response
     */
    data?: UpdateProtocolDeployment200ResponseData;
}

/**
 * Check if a given object implements the UpdateProtocolDeployment200Response interface.
 */
export function instanceOfUpdateProtocolDeployment200Response(value: object): value is UpdateProtocolDeployment200Response {
    return true;
}

export function UpdateProtocolDeployment200ResponseFromJSON(json: any): UpdateProtocolDeployment200Response {
    return UpdateProtocolDeployment200ResponseFromJSONTyped(json, false);
}

export function UpdateProtocolDeployment200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProtocolDeployment200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : UpdateProtocolDeployment200ResponseDataFromJSON(json['data']),
    };
}

export function UpdateProtocolDeployment200ResponseToJSON(json: any): UpdateProtocolDeployment200Response {
    return UpdateProtocolDeployment200ResponseToJSONTyped(json, false);
}

export function UpdateProtocolDeployment200ResponseToJSONTyped(value?: UpdateProtocolDeployment200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': UpdateProtocolDeployment200ResponseDataToJSON(value['data']),
    };
}

